import { addClass, removeClass } from "./_classesHelper";
class HeaderScrollAni {
  constructor() {
    this.header = document.querySelector(".js-global-header");
    this.headerContainer = document.querySelector(".js-global-header__content");
    this.headerPlaceholder = document.querySelector(".js-header-scrollable"); //prettier-ignore
    this.headerHeight = (this.headerContainer) ? this.headerContainer.offsetHeight : 0;
    this.headerPlaceholderArray = [...document.querySelectorAll(".js-header-placeholder")]; //prettier-ignore
    this.lastScrollPosition = 0;
    this.visibleClass = "is-visible";
    this.stickyClass = "is-sticky";
    this.transparentClass = "is-transparent";

    this.init();
  }

  init() {
    this.setHeight(this.headerPlaceholderArray, this.headerHeight);
    window.addEventListener("resize", () => {
      this.headerHeight = (this.headerContainer) ? this.headerContainer.offsetHeight : 0;
      this.setHeight(this.headerPlaceholderArray, this.headerHeight);
    });
    window.addEventListener("scroll", () => {
      this.scrollAnimation();
    });
  }

  scrollAnimation() {
    let headerPosition = this.headerPlaceholder.getBoundingClientRect();
    let isScrollingUp = this.isScrollingUp();
    let headerIsSticky = this.header.classList.contains(this.stickyClass);

    if (headerPosition.bottom < 0) {
      addClass(this.header, this.transparentClass);
      setTimeout(() => {
        addClass(this.header, this.stickyClass);
      }, 100);
    } else if (headerPosition.top > -10 && headerIsSticky) {
      removeClass(this.header, this.transparentClass);
      removeClass(this.header, this.stickyClass);
      removeClass(this.header, this.visibleClass);
    }

    if (isScrollingUp) {
      addClass(this.header, this.visibleClass);
    }

    if (!isScrollingUp && headerIsSticky) {
      removeClass(this.header, this.visibleClass);
    }
  }

  isScrollingUp() {
    const bodyScrollTop =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (bodyScrollTop > this.lastScrollPosition) {
      this.lastScrollPosition = bodyScrollTop;
      return false;
    } else {
      this.lastScrollPosition = bodyScrollTop;
      return true;
    }
  }

  setHeight(elements, height) {
    height = height + 2;
    elements.forEach((element) => {
      element.style.height = `${height}px`;
    });
  }
}

export default HeaderScrollAni;
